import { render, staticRenderFns } from "./futureBaby.vue?vue&type=template&id=3ae3f6a4&scoped=true&"
import script from "./futureBaby.vue?vue&type=script&lang=ts&"
export * from "./futureBaby.vue?vue&type=script&lang=ts&"
import style0 from "./futureBaby.scss?vue&type=style&index=0&id=3ae3f6a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae3f6a4",
  null
  
)

export default component.exports